import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping, faMagnifyingGlass,faTimes} from "@fortawesome/free-solid-svg-icons";


export const Header = () => {

  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="container py-2">
      <div className="row d-flex justify-content-between align-items-center">
        <div className="col">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img src="images/logo.png" alt="logo" />
            </a>
            <button
              className="navbar-toggler order-md-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded={isMenuOpen ? "true" : "false"}
              aria-label="Toggle navigation"
              onClick={handleToggleMenu}
            >
              {isMenuOpen ? (
                <FontAwesomeIcon icon={faTimes} />
              ) : (
                <span className="navbar-toggler-icon"></span>
              )}
            </button>

            <Navbar.Collapse
              className={`collapse navbar-collapse justify-content-evenly ${
                isMenuOpen ? "show" : ""
              }`}
              id="navbarSupportedContent"
            >
              <Nav className="navbar-nav">
                <NavDropdown title="HOME" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#another-action">
                    Another action
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="SHOP" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#another-action">
                    Another action
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="WOMEN'S" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#another-action">
                    Another action
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="MEN'S" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#another-action">
                    Another action
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="TODAY'S DEALS" id="basic-nav-dropdown">
                  <NavDropdown.Item href="#action">Action</NavDropdown.Item>
                  <NavDropdown.Item href="#another-action">
                    Another action
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="PAGES" id="basic-nav-dropdown">
                  <NavDropdown.Item href="/about">About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/faq">FAQ's</NavDropdown.Item>
                  <NavDropdown.Item href="/customerservice">
                    Customer Services
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/contact">
                    Contact Us
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>

            <div className="header-right d-md-flex">
              <div className="search m-lg-2">
                <Link to="/search">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </Link>
              </div>
              <div className="user m-lg-2">
                <Link to="/login">LOGIN</Link>
              </div>
              <div className="user m-lg-2">
                <Link to="/cart">
                  CART() <FontAwesomeIcon icon={faBagShopping} />
                </Link>
              </div>
              
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};